var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    fillRule: "evenodd",
    d: "M2.262 15.455a2.6 2.6 0 0 1-1.043-.602 2.5 2.5 0 0 1-.642-1.003c-.734-1.964-.952-10.165.462-11.783a2.74 2.74 0 0 1 1.849-.903C6.68.766 18.398.82 19.743 1.297c.379.12.725.322 1.012.59.287.27.508.598.646.962.802 2.03.83 9.408-.108 11.359-.249.508-.665.919-1.183 1.168-1.413.69-15.972.676-17.848.08m6.022-3.848 6.797-3.45-6.797-3.476z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;